import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TimeLine from 'Components/TimeLine';
import FilterPanel from 'Components/FilterPanel';
import CaseEventsLog from 'Components/CaseEventsLog';

import './TimeLineSection.scss';


const TimeLineSection = (props) => {
  const [data, setData] = useState([]);
  const [baseData, setBase] = useState([]);
  const [dataSort, setSort] = useState(false);
  const [stageMap, setStageMap] = useState({});
  const [baseMap, setBaseMap] = useState({});
  const [filter, setFilter] = useState('All');
  const [showCaseTimelineFlag, setCaseTimelineFlag] = useState('Case Timeline');
  const [caseNumber, setCaseNumber] = useState(props.caseNumber);
  const [sectionFilters, setsectionFilters] = useState({
    countAction : 0, countDoc : 0, countNotes: 0, countMerchAdv:0, countFinancial: 0,countReasonAdditionalReview:0,
  });
  const [filterSet, setFilterSet] = useState(['All']);

  const sortDataByTime = (sortedBy, dataSet = data) => {
    setSort(!dataSort);
    dataSet = sortData(dataSet,sortedBy);
    setData(dataSet);
  };

  const showTimelineOrHistory = (select) => {

    if (select !== showCaseTimelineFlag) { setCaseTimelineFlag(select); }
  }

  const mapData = (res) => {
    if (res !== undefined) {
      const stageUpdate = {};
      const response = res;
      let updateRes = response;
      if (response.length) {
        const stages = [...new Set(response.map(x => x.caseStageId))];
        const stageElements = [];
        stages.forEach((stage, i) => {
          let object = response.find(item => item.caseStageId === stages[i] && item.caseStageId === item?.eventHeaderDetails?.responseToCaseStageId);
          if(!object){
            object = response.find(item => item.caseStageId === stages[i]);
          }
          const stageObject = {
            caseStageId: object.caseStageId,
            disputeStageName: object.disputeStageName,
            disputeStageStatus: object.disputeStageStatus,
            merchantChallengeType: object.merchantChallengeType,
            stageElement: true,
            eventHeaderDetails: {
              eventTimeStamp: object.eventHeaderDetails.eventTimeStamp,
              eventGeneratedByUser: object.eventHeaderDetails.GeneratedByUser,
              recordType: object.eventHeaderDetails.recordType,
              disputeStageType: object.eventHeaderDetails.disputeStageType,
              latestStageIndicator: object.eventHeaderDetails.latestStageInd,
              activeStageIndicator: object.eventHeaderDetails.activeStageInd
            },
            eventBodyDetails: {},
          };
          stageElements.push(stageObject);
        });
        updateRes = [...stageElements, ...response];
        updateRes.forEach((item) => {
          if (item.stageElement && item.stageElement === true) stageUpdate[item.caseStageId] = { isOpen: false };
        });
        updateRes = sortData(updateRes,'compareDesc');
      }
      setData(updateRes);
      setBase(updateRes);
      setBaseMap(stageUpdate);
      countUpdate(updateRes);
      return stageUpdate;
    }
    return {};
  };

  const countUpdate = (dataCount) => {
    const updateList = dataCount.filter((filter) => {
      return filter.eventHeaderDetails.eventCode && (['CHALLENGE','PURSUE_CASE_FILING','UNABLE_TO_FULFILL','MERCHANT_ACCEPT_LIABILITY','MERCHANT_REJECTED_CASE','FULFILL_REQUEST','MERCHANT_DENY','MERCH_UNABLE_TO_FULFILL','MERCHANT_CASE_NOTE_ADDED','DOCUMENT_LINKING','UPLOAD_DOCUMENT','DOCUMENT_ATTACHED','NOTIFY_AND_REQUEST_DOCS', 'REQUEST_ADDITIONAL_INFO', 'CASE_NOTE', 'EXTERNAL_CASE_NOTE', 'RESPONSE_TO_ISSUER', 'UNABLE_TO_DEFEND', 'WRITE_OFF_GOODWILL', 'CASE_CLOSE', 'DECISION_WON', 'DECISION_PARTIAL', 'DECISION_LOST', 'CONFIRMATION_ACCEPTED', 'CONFIRMATION_REJECTED', 'RESPOND_TO_CARD_BRAND','TRANSFER_CASE','CREATE_DOCUMENT','UNRESOLVE_RTI','RULING_WON','RULING_LOST' , 'CONFIRMATION_NOT_EXPECTED', 'DECISION_NOT_EXPECTED', 'MANUALLY_PROCESSED', 'SUMMARY_DOCUMENT_ATTACHED']).includes(filter.eventHeaderDetails.eventCode);
     });
    let actionCount = 0; 
    let docCount = 0; 
    let notesCount = 0; 
    let merchAdvCount = 0; 
    let financialCount = 0; 
    let reasonAdditionalReviewCount = 0;
    updateList && updateList.map((item) => {
       return item.eventBodyDetails !== undefined && item.eventBodyDetails.length > 0 && item.eventBodyDetails.forEach((term,index) => {
           if(term.sectionCode === 'ACTION') {
            actionCount++
           } 
           if(term.sectionCode === 'ACTION_MERCHANT') {
            actionCount++
           } 
           if(term.sectionCode === 'DOCUMENTS' && term.fields.DocumentList && term.fields.DocumentList.length > 0) {
            docCount++
           }
           if(term.sectionCode === 'RSN_ADTNL_RVW') {
            reasonAdditionalReviewCount++
           } 
           if(term.sectionCode === 'MERCHANT_ADVICE') {
            merchAdvCount++
           } 
           if(term.sectionCode === 'NOTES') {
            notesCount++
           } 
           if(term.sectionCode === 'EXTERNAL_NOTES') {
            notesCount++
           } 
           if(term.sectionCode === 'FINANCIALS') {
            financialCount++
           } 
       })
    })
    setsectionFilters({countAction : actionCount, countDoc : docCount, countNotes: notesCount, countMerchAdv:merchAdvCount, countFinancial: financialCount,countReasonAdditionalReview: reasonAdditionalReviewCount,});
  }

  const updateMap = (id) => {
    let updatedMap;
    setStageMap(prevState => {
      updatedMap = { ...prevState };
      updatedMap[id].isOpen = !updatedMap[id].isOpen;
      return updatedMap;
    });
  };
  useEffect(() => {
    setCaseNumber(props.caseNumber);
    return () => {
      setData([]);
      setBase([]);
      setStageMap({});
      setBaseMap({});
      setFilterSet(['All']);
      setCaseNumber('');
    };
  }, [props.caseNumber]);

  useEffect(() => {
    if (props?.caseLandingHistory?.length > 0) {
      setStageMap(mapData(props.caseLandingHistory));
      setFilterSet(['All']);
    }
    setSort(!dataSort);
  }, [props.caseLandingHistory, props.caseNumber]);

  const getCheck = (select) => {
    let finalCheckList = [];
    setStageMap(updateStageMap());
    setSort(!dataSort);
    setFilter(select);
    if (select.includes('Financials')) {
      const financial = ['FINANCIALS'];
      finalCheckList = finalCheckList.concat([...financial]);
    }
    if (select.includes('Documents')) {
      const attachments = ['DOCUMENTS'];
      finalCheckList = finalCheckList.concat([...attachments]);
    }
    if (select.includes('Summary Document')) {
      const attachments = ['SUMMARY_DOC'];
      finalCheckList = finalCheckList.concat([...attachments]);
    }
    if (select.includes('Reason for Additional Review')) {
     const reasonAdditionalReview = ['RSN_ADTNL_RVW'];
      finalCheckList = finalCheckList.concat([...reasonAdditionalReview]);
    }
    if (select.includes('Merchant Advice')) {
      const merchantAdvice = ['MERCHANT_ADVICE'];
       finalCheckList = finalCheckList.concat([...merchantAdvice]);
     }
    if (select.includes('Action')) {
      const actions = ['ACTION'];
      finalCheckList = finalCheckList.concat([...actions]);
    }
    if (select.includes('Action')) {
      const actions = ['ACTION_MERCHANT'];
      finalCheckList = finalCheckList.concat([...actions]);
    }
    if (select.includes('Notes')) {
      const notes = ['NOTES','EXTERNAL_NOTES'];
      finalCheckList = finalCheckList.concat([...notes]);
    }
    if (select.includes('All')) {
      finalCheckList = ['All'];
    }
    return finalCheckList;
  };

  const filterByType = (select, box2, box3) => {
    setStageMap(baseMap);
    setSort(!dataSort);
    const check = getCheck(select);
    return setFilterSet(check);
  };

  const updateStageMap = () => {
    let stageUpdate = [];
    baseData.forEach((item) => {
      if (item.stageElement && item.stageElement === true) stageUpdate[item.caseStageId] = { isOpen: true };
    });
    setBaseMap(stageUpdate);
    return stageUpdate;
  }

  const filterByParty = (select, box1, box2) => {
    setStageMap(baseMap);
    setSort(!dataSort);
    const check = getCheck(box1);
    const updateList = baseData.filter((item) => {
      if (check.includes('RETURN_ALL')) return item;
      if (select === 'ALL') {
        return item;
      }
      if (check.includes('STAGE_UPDATED')) {
        return check.includes(item.eventHeaderDetails.eventCode) || item.stageElement;
      }
      return check.includes(item.eventHeaderDetails.eventCode);
    });
    const returnList = updateList.filter((item) => {
      if (select === 'Anyone') {
        return item;
      }
      return item.eventBodyDetails.GeneratedByUser === select;
    });
    if (box2 !== 'Newest First') {
      return sortDataByTime('compareAsc', returnList);
    } else {
      return setData(returnList);
    }
  };

  return (
    <div className="timeline-section">
      <div className="main-content timeline">
        <FilterPanel
          sortDataByTime={sortDataByTime}
          filterByType={filterByType}

          filterByParty={filterByParty}
          data={baseData}
          showTimelineOrHistory={showTimelineOrHistory}
          showCaseTimelineFlag={showCaseTimelineFlag}
          sectionFilters={sectionFilters}
          isCaseFailedToLoad={props.isCaseFailedToLoad}
        />
        {showCaseTimelineFlag === 'Case Events Log' &&
          <CaseEventsLog
            historyData={props.historyData}
            historyDataErr={props.historyDataErr}
            historyDataLoading={props.historyDataLoading}
            dateFormat ={props.dateFormat}
            timeFormat ={props.timeFormat}
          />
        }        
        {showCaseTimelineFlag !== 'Case Events Log' && baseData.length > 0 && baseData[0].caseStageId && !props.isCaseFailedToLoad && (
          <TimeLine
            isReadOnly={props.isReadOnly}
            displayData={data}
            dataSort={dataSort}
            stageMap={stageMap}
            updateMap={updateMap}
            filter={filter}
            auth={props.auth}
            // getCaseHistory={props.getCaseHistory}
            caseNumber={caseNumber}
            callUnlinkBanner={props.callUnlinkBanner}
            toggleDrawer={props.toggleDrawer}
            getApiDrawerData={props.getApiDrawerData}
            configId={props.configId}
            filterSet={filterSet}
            dateFormat ='MMM dd, yyyy '
            timeFormat = 'hh:mm a'
            cardBrandCode = {props.cardBrandCode}
            historyData = {props.historyData}
            getCaseDetails={props.getCaseDetails}
            getFetchCaseLoader={props.getFetchCaseLoader}
            setActiveStageIndicatorSettingsOpenFlag={props.setActiveStageIndicatorSettingsOpenFlag}
          />
        )}
      </div>
    </div>
  );
};


TimeLineSection.propTypes = {
  auth: PropTypes.object,
  caseLandingHistory: PropTypes.array,
  caseNumber: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
  getAuthData: PropTypes.func,
  getTranData: PropTypes.func,
  getCreditTranData : PropTypes.func,
  getCaseData: PropTypes.func,
  getSchemeData: PropTypes.func,
};

TimeLineSection.defaultProps = {
  auth: {},
  caseLandingHistory: [],
  getAuthData: () => { },
  getTranData: () => { },
  getCreditTranData: () => { },
  getCaseData: () => { },
  getSchemeData: () => { },
};

function sortData(dataSet,sortedBy) {

  if(sortedBy=='compareDesc'){
    dataSet = dataSet.sort(function (a, b) {
      if (a.caseStageId > b.caseStageId)
        return -1; // if a doesn't have a name and b does, then put a above b
      if (a.caseStageId < b.caseStageId)
        return 1; // if b doesn't have a name and a does, then put b above a
      if (a.stageElement && !b.stageElement)
        return -1; // otherwise (a and b have simillar properties), then sort by createdAt descendently
      if (!a.stageElement && b.stageElement)
        return 1;
      if ((a.eventBodyDetails.EventTimeStamp || a.eventHeaderDetails.eventTimeStamp) > (b.eventBodyDetails.EventTimeStamp || b.eventHeaderDetails.eventTimeStamp))
        return -1; // if a is featured and b is not, then put a above b
      if ((a.eventBodyDetails.EventTimeStamp || a.eventHeaderDetails.eventTimeStamp) < (b.eventBodyDetails.EventTimeStamp || b.eventHeaderDetails.eventTimeStamp))
        return 1; // if b is featured and a is not, then put b above a
    });
  }else{
  dataSet = dataSet.sort(function (a, b) {
    if (a.caseStageId < b.caseStageId)
      return -1; // if a doesn't have a name and b does, then put a above b
    if (a.caseStageId > b.caseStageId)
      return 1; // if b doesn't have a name and a does, then put b above a
    if (a.stageElement && !b.stageElement)
      return -1; // otherwise (a and b have simillar properties), then sort by createdAt descendently
    if (!a.stageElement && b.stageElement)
      return 1;
    if ((a.eventBodyDetails.EventTimeStamp || a.eventHeaderDetails.eventTimeStamp) < (b.eventBodyDetails.EventTimeStamp || b.eventHeaderDetails.eventTimeStamp))
      return -1; // if a is featured and b is not, then put a above b
    if ((a.eventBodyDetails.EventTimeStamp || a.eventHeaderDetails.eventTimeStamp) > (b.eventBodyDetails.EventTimeStamp || b.eventHeaderDetails.eventTimeStamp))
      return 1; // if b is featured and a is not, then put b above a
  });
}
  return dataSet;
}

export default TimeLineSection;
